import { render, staticRenderFns } from "./attraction.vue?vue&type=template&id=32a26e4d&scoped=true&"
import script from "./attraction.vue?vue&type=script&lang=js&"
export * from "./attraction.vue?vue&type=script&lang=js&"
import style0 from "./attraction.vue?vue&type=style&index=0&id=32a26e4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a26e4d",
  null
  
)

export default component.exports